var app = angular.module('leonardo');

var TranslationService = function(BaseRestService) {
  var service = new BaseRestService('translate');
  return service;
};

app.factory('TranslationService', ['BaseRestService', TranslationService]);